import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedModules } from "src/app/shared.modules";
import { DialogFinishPlanComponent } from "./dialog-finish-plan.component";
import { DialogDefaultModalComponent } from "../dialog-default-modal/dialog-default-modal.component";
import { ButtonComponent } from "../button/button.component";

@NgModule({
  declarations: [DialogFinishPlanComponent],
  imports: [
    CommonModule,
    SharedModules,
    DialogDefaultModalComponent,
    ButtonComponent,
  ],
  exports: [DialogFinishPlanComponent],
})
export class DialogFinishPlanModule {}
